import classNames from 'classnames';

import { numberToCurrency } from 'my-utils';

import Label from 'my-elements/Label';

import ButtonBase from '@mui/material/ButtonBase';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

export default function ProductPricesSelect({ activePrice, className, onChange, product }) {
  return (
    <Grid
      className={className}
      container
      spacing={2}
      sx={{
        '.price-item': {
          width: '100%',
          height: '100%',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          py: 2,
          px: 1,
          backgroundColor: 'background.paper',
          borderRadius: 1,
          border: '1px solid',
          borderColor: 'divider',
          '&.price-item_active': {
            borderColor: 'primary.main',
          },
        },
      }}
    >
      {product.prices.map(price => (
        <Grid key={price.id} size="grow">
          <ButtonBase
            className={classNames('price-item', { 'price-item_active': activePrice === price.id })}
            onClick={() => onChange(price.id)}
          >
            <Label color={price.primary ? 'primary' : 'black'} label={price.label} />
            <Typography sx={{ color: 'text.secondary', mt: 0.5 }} variant="body2">
              {price.name}
            </Typography>
            <Typography sx={{ mt: 1 }} variant="h5">
              {numberToCurrency(price.amount / 100)}{' '}
              {price.recurring && (
                <Typography component="span" variant="subtitle1">
                  / {price.interval_unit}
                </Typography>
              )}
            </Typography>
          </ButtonBase>
        </Grid>
      ))}
    </Grid>
  );
}
